import { k } from "../kaplay";

import { life } from "../components/life";
import { swords } from "../components/swords";

import { createGameManager } from "../managers/gameManager"

k.scene("game", () => {
  
  // Corners
  k.add([k.rect(10, 10), k.pos(0, 0)])
  k.add([k.rect(10, 10), k.pos(k.width() - 10, 0)])
  k.add([k.rect(10, 10), k.pos(0, k.height() - 10)])
  k.add([k.rect(10, 10), k.pos(k.width() - 10, k.height() - 10)])

  // Player
  const player = k.add([
    "player",

    k.pos(k.center()),
    k.sprite("player"),
    k.anchor("center"),
    k.area({ scale: 0.7 }),
    k.layer("foreground"),
    life({ maxLife: 20 }),
    swords(),
  ]);

  player.onDestroy(async () => {
    await k.wait(5);
    k.go("menu");
  })

  // Hearts
  player.onUpdate(() => {
    k.get("heart").forEach((h) => h.destroy());

    for (let i = 0; i < player.life; i++){
      const xPos = 24 + i * 52;
      const yPos = k.height() - 24;

      k.add([
        "heart",

        k.sprite("heart"),
        k.layer("ui"),
        k.anchor("botleft"),
        k.pos(xPos, yPos)
      ])
    }
  })

  // Ennemies
  k.onCollide("enemy", "player", (enemy, player) => {
    enemy.takeDamage(9999999999999999);
    player.takeDamage(enemy.damage);
  })

  k.onCollide("enemy", "attack_enemy", (enemy, attacker) => {
    attacker.attacked();
    enemy.takeDamage(attacker.damage);
  })

  k.onDestroy("enemy", (enemy) => {
    xpSystem.xp += enemy.xp;
  })


  // Exp
  const xpSystem = k.add([
    "xp",

    k.text("0", { size: 64, font: "happy-o" }),
    k.pos(420, 36),
    k.layer("ui"),
    k.anchor("left"),

    { xp: 0, next: 100, level: 0 }
  ])

  const maxWidth = 400-36;
  const xpRect = k.add([
    k.pos(24, 36),
    k.layer("ui"),
    k.anchor("left"),
    k.rect(0, 20),
    k.color(k.Color.fromHex("#953aca"))
  ])

  k.add([
    k.sprite("xpBar"),
    k.pos(24, 36),
    k.layer("ui"),
    k.anchor("left"),
  ])

  k.onUpdate("xp", (system) => {
    if (system.xp >= system.next){
      system.xp -= system.next;
      // Passage à une progression linéaire
      system.level++;

      system.next = Math.round(100 + 70 * system.level + system.next * 0.3);

      const gameManager = k.get("gameManager")[0];
      gameManager.enterState("card");
      system.text = system.level;
    }
    xpRect.width = (system.xp / system.next) * maxWidth;
  })


  // Waves
  const waveText = k.add([
    "wave",

    k.text(" Wave 0", { size: 64, font: "happy-o", align: "right" }),
    k.pos(k.width() - 24, 36),
    k.anchor("right"),
    k.layer("ui"),
  ])

  k.onUpdate("wave", (system) => {
    const gameManager = k.get("gameManager")[0];
    system.text = "Wave " + gameManager.waveNumber;
  })

  createGameManager();
})